"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Address = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Address = _styledComponents["default"].address(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 0px;\n\n    p {\n        margin-bottom: 0.1rem;\n        font-size: 0.8rem;\n\n        &.address-name {\n            font-size: 1rem;\n            margin-bottom: 0.2rem;\n        }\n    }\n"])));

exports.Address = Address;